const getISOFormattedDate = (dateString: string) => {
  const [year, month, day] = dateString.split('-').map(Number)
  const utcTimestamp = Date.UTC(year, month - 1, day)

  return new Date(utcTimestamp).toISOString().split('T')[0]
}

export default getISOFormattedDate
